module.exports = __webpack_public_path__ + "assets/images/scene-1_f77af4e9773b0ba2119db4ee2623ddde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/croma-abeldo-dialogs/scene-1.png
// module id = 274
// module chunks = 0